module.exports = __webpack_public_path__ + "assets/img/title-69eec1ae.png";